// extracted by mini-css-extract-plugin
export default {"container":"styles_container__LZDlK","content":"styles_content__GQse3","back_button":"styles_back_button__86aPo"};